import type { FaireProductEntity } from "../../entity_types/product";

export const p_2rr2vul1x9: FaireProductEntity = {
  token: "p_2rr2vul1x9",
  type: "product",
  name: "Kids Relief Teething Oral Liquid for Kids 0-9 Years, 25 mL",
  brandToken: "b_7btl61xote",
  brandName: "homeolab International Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/63efa9ba051f3d93ffe8e3a0597292c771365e714eaa74a0a1f41f0dd5240791.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/062dc731fe18ba7afd3623dc848477a55f7e71efe69e40c0c0f7d6bf2a73f132.webp",
    "https://cdn.faire.com/fastly/ef9d358215c6daca131492e63793a31adab9e61616f407a7f7dc2334464a7cc7.jpeg",
    "https://cdn.faire.com/fastly/3e851ab83c4754237a6e2179948f2c4046cf4ab12a01dd4211f20a8a7d4b2f40.jpeg",
    "https://cdn.faire.com/fastly/2c3cafe7b3bc42d8b391d4029c84191c0b9ece665a5cf98685c38e0470d2a3f8.jpeg",
    "https://cdn.faire.com/fastly/6a7a8e5a58b7c308ada1811d250bdf0eaffd5c8b30f603e562e4107f87466a61.jpeg",
  ],
  priceDollars: 8.3,
  description:
    "The emergence of your baby’s first teeth is an exciting milestone, but also an irritating one. Let Kids Relief Teething Oral Liquid help you through this time by providing pain relief while treating restlessness, irritability and agitation. Kids Relief Teething is a great-tasting, easy-to-administer Oral Liquid that gets to the source quickly to help eliminate your baby’s discomfort.\n\nSafe - Our Teething oral liquid is sealed with a childproof cap. There are no Side Effects, (No drug interactions), Gluten-free, Dye-free and Sugar-free.\n\nThis homoeopathic medicine helps relieve symptoms associated with: Soothing gum pain, Reducing restlessness, irritability and agitation, Relieving diarrhea.\n\nOur Teething oral liquid comes in a great tasting orange flavor and provides up to 30-50 individual doses per bottle depending on your child's age. they are easy to measure with the measuring dropper included in the box.\n",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:30.203Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
